import { render, staticRenderFns } from "./permissionedit.vue?vue&type=template&id=2f6099c8"
import script from "./permissionedit.vue?vue&type=script&lang=ts"
export * from "./permissionedit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports